import { PaymentAction } from '@adyen/adyen-web/dist/types/types';
import React from 'react';
import { SCAState, SCAType } from './adyen_sca_hook';
import SCAChallengeShopper from './sca_challenge_shopper';
import SCARedirectShopper from './sca_redirect_shopper';

interface Props {
  action: PaymentAction;
  onPaymentDetailResult(threeds2Result: string): void;
}

export default function SCAInteraction(props: Props) {
  function onAdditionalDetails(state: SCAState) {
    // state.data.details only contains 'threeDSResult' in checkout API v67
    // https://docs.adyen.com/online-payments/3d-secure/native-3ds2/web-component?tab=v67-submit_1
    // @ts-ignore ["threeDSResult"] is better written in dot notation
    props.onPaymentDetailResult(state.data.details.threeDSResult);
  }

  // Action type will either be 'threeDS2' or 'redirect' (checkout API v67)
  // for backwards compatibility, check props.action.type for v66
  // https://docs.adyen.com/online-payments/3d-secure/native-3ds2/web-component?tab=v67-payment-response_1
  if (props.action.type === SCAType.Redirect) {
    return (<SCARedirectShopper action={props.action} />);
  }

  return (
    <SCAChallengeShopper
      action={props.action}
      onAdditionalDetails={onAdditionalDetails}
    />
  );

  return null;
}
